import React from "react";
import { NakiNigunAlbumTrackListLoaderTemplate } from "themes/administration/naki-nigun/components";

const NakiNigunAlbumTrackListLoader = (props) => {
    return <NakiNigunAlbumTrackListLoaderTemplate {...props} />;
};

export default NakiNigunAlbumTrackListLoader;
